import { render, staticRenderFns } from "./EditGraphics.vue?vue&type=template&id=9b65a4b8&scoped=true&"
import script from "./EditGraphics.vue?vue&type=script&lang=js&"
export * from "./EditGraphics.vue?vue&type=script&lang=js&"
import style0 from "./EditGraphics.vue?vue&type=style&index=0&id=9b65a4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b65a4b8",
  null
  
)

export default component.exports